//import { lazy } from 'react'

import Assegnazioni from './assegnazioni'
import Consuntivi from './consuntivi'

import createCasiFilter from './filter'
import createCasiDetail from './detail'

export const createCasi = ({ filterPath }) => ({
    path: filterPath,
    title: 'Casi',
    authenticated: true,
    component: createCasiFilter({ filterPath }),
    pages: [
        {
            path: '/:casoId',
            title: 'Caso: {{params.casoId}}',
            drawer: false,
            component: createCasiDetail({ filterPath }),
            pages: [Assegnazioni, Consuntivi]
        }
    ]
})

export default createCasi({ filterPath: '/casi' })